/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 9);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

// Thank's IE8 for his funny defineProperty
module.exports = !__webpack_require__(7)(function () {
  return Object.defineProperty({}, 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),
/* 1 */
/***/ (function(module, exports) {

module.exports = function (it) {
  return typeof it === 'object' ? it !== null : typeof it === 'function';
};


/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

exports.default = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _defineProperty = __webpack_require__(11);

var _defineProperty2 = _interopRequireDefault(_defineProperty);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      (0, _defineProperty2.default)(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

/***/ }),
/* 4 */
/***/ (function(module, exports) {

// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var global = module.exports = typeof window != 'undefined' && window.Math == Math
  ? window : typeof self != 'undefined' && self.Math == Math ? self
  // eslint-disable-next-line no-new-func
  : Function('return this')();
if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef


/***/ }),
/* 5 */
/***/ (function(module, exports) {

var core = module.exports = { version: '2.5.7' };
if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef


/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(18);
var IE8_DOM_DEFINE = __webpack_require__(19);
var toPrimitive = __webpack_require__(21);
var dP = Object.defineProperty;

exports.f = __webpack_require__(0) ? Object.defineProperty : function defineProperty(O, P, Attributes) {
  anObject(O);
  P = toPrimitive(P, true);
  anObject(Attributes);
  if (IE8_DOM_DEFINE) try {
    return dP(O, P, Attributes);
  } catch (e) { /* empty */ }
  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};


/***/ }),
/* 7 */
/***/ (function(module, exports) {

module.exports = function (exec) {
  try {
    return !!exec();
  } catch (e) {
    return true;
  }
};


/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = __webpack_require__(2);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(3);

var _createClass3 = _interopRequireDefault(_createClass2);

var _consts = __webpack_require__(25);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

__webpack_require__(26);

var BrandSubNavigation = function () {
  function BrandSubNavigation() {
    (0, _classCallCheck3.default)(this, BrandSubNavigation);

    this.menuBarSelector = document.querySelector('.' + _consts.consts.BRAND_NAVIGATION_TOP_MENU_BAR);
    this.breadcrumbSelector = document.querySelector('.' + _consts.consts.BRAND_SUB_NAVIGATION_BREADCRUMB);
    this.dropdownSelectors = document.querySelectorAll('.' + _consts.consts.BRAND_NAVIGATION_TOP_MENU_LINK);
    this.subNavDOMelems = document.querySelectorAll('.' + _consts.consts.BRAND_SUB_NAV);
    this.subNavTagClass = this.breadcrumbSelector.getAttribute(_consts.consts.BRAND_SUB_NAV_TAG_CLASS);
    this.subNavTags = document.querySelectorAll('.' + this.subNavTagClass);
    this.navBarVisibilityBtn = null;
    if (this.subNavDOMelems.length > 0 && this.subNavTags.length > 0) {
      this.loadSubNavBars();
    } else {
      for (var i = 0; i < this.subNavDOMelems.length; i++) {
        this.subNavDOMelems[i].remove();
      }
    }
  }

  (0, _createClass3.default)(BrandSubNavigation, [{
    key: 'loadSubNavBars',
    value: function loadSubNavBars() {
      for (var i = 0; i < this.subNavDOMelems.length; i++) {
        var brandSubNavContentDOMelem = this.subNavDOMelems[i].querySelector('.' + _consts.consts.BRAND_SUB_NAV_CONTENT);
        var childNodesLength = brandSubNavContentDOMelem.childNodes.length - 1;
        var replaceElem = brandSubNavContentDOMelem.childNodes[childNodesLength];
        brandSubNavContentDOMelem.replaceChild(this.generateDropdownTriggerDOMelem(replaceElem.textContent), replaceElem);
        this.subNavDOMelems[i].appendChild(this.generateSubNavDropdownDOMelem());
      }
      this.injectVisibiltyBtn();
      this.toggleAnimations();
      this.toggleBarVisibilityChange();
      this.activeSubNavTag = document.querySelector('[href=\'#' + this.subNavTagClass + '0\']');
    }
  }, {
    key: 'generateDropdownTriggerDOMelem',
    value: function generateDropdownTriggerDOMelem(label) {
      var elem = document.createElement('div');
      elem.className = _consts.consts.BRAND_SUB_NAV_CONTENT_TRIGGER;
      elem.onclick = this.toggleSubNavDropdown;
      elem.innerHTML = '' + label;
      return elem;
    }
  }, {
    key: 'generateSubNavDropdownDOMelem',
    value: function generateSubNavDropdownDOMelem() {
      var subNavDropdown = document.createElement('ul');
      window.addEventListener('load', function () {
        var dropdownTriggerRect = document.querySelector('.' + _consts.consts.BRAND_SUB_NAV_CONTENT_TRIGGER).getBoundingClientRect();
        subNavDropdown.style.paddingLeft = dropdownTriggerRect.left + 'px';
      });
      subNavDropdown.className = _consts.consts.BRAND_SUB_NAV_DROPDOWN;
      subNavDropdown.innerHTML = '<a class=\'' + _consts.consts.BRAND_SUB_NAV_NAVTAG + '\'>Top</a>';
      var documentTags = document.querySelectorAll('.' + this.subNavTagClass);
      for (var i = 0; i < documentTags.length; i++) {
        documentTags[i].id = '' + this.subNavTagClass + i;
        subNavDropdown.innerHTML += '<li><a class=\'' + _consts.consts.BRAND_SUB_NAV_NAVTAG + '\' href=\'#' + this.subNavTagClass + i + '\'>' + documentTags[i].textContent + '</a></li>';
      }
      return subNavDropdown;
    }
  }, {
    key: 'injectVisibiltyBtn',
    value: function injectVisibiltyBtn() {
      var _this = this;

      var statusContainer = document.querySelector('.' + _consts.consts.BRAND_HEADER_STATUS_CONTAINER);
      if (statusContainer) {
        this.navBarVisibilityBtn = document.createElement('a');
        this.navBarVisibilityBtn.className = _consts.consts.BRAND_NAVIGATON_TOP_MENU_BAR_VISIBILITY_BTN + ' ' + _consts.consts.BRAND_NAVIGATON_TOP_MENU_BAR_VISIBILITY_BTN_VISIBLE;
        this.navBarVisibilityBtn.addEventListener('click', function () {
          if (_this.isOpenDropdown()) return;
          _this.navBarVisibilityBtn.classList.contains(_consts.consts.BRAND_NAVIGATON_TOP_MENU_BAR_VISIBILITY_BTN_VISIBLE) ? _this.hideNavBar() : _this.showNavBar();
        });
        statusContainer.appendChild(this.navBarVisibilityBtn);
      } else {
        console.error('Brand Navigation error. Failed to inject visibility button. Unable to find status container');
      }
    }
  }, {
    key: 'toggleSubNavDropdown',
    value: function toggleSubNavDropdown() {
      var tagsBar = document.querySelector('.' + _consts.consts.BRAND_SUB_NAV_DROPDOWN);
      tagsBar.classList.toggle(_consts.consts.BRAND_SUB_NAV_DROPDOWN_VISIBLE);
    }
  }, {
    key: 'toggleAnimations',
    value: function toggleAnimations() {
      var _this2 = this;

      var inPageTags = document.querySelectorAll('.' + _consts.consts.BRAND_SUB_NAV_NAVTAG);
      var isSmoothScrollSupported = 'scrollBehavior' in document.documentElement.style;
      var animFunction = isSmoothScrollSupported ? this.scrollToElement : this.scrollToElementManual;

      var _loop = function _loop(i) {
        var targetTag = inPageTags[i].getAttribute('href');
        inPageTags[i].addEventListener('click', function (el) {
          el.preventDefault();
          i === 0 ? _this2.scrollToTop(200) : animFunction(targetTag);
        });
      };

      for (var i = 0; i < inPageTags.length; i++) {
        _loop(i);
      }
    }
  }, {
    key: 'toggleBarVisibilityChange',
    value: function toggleBarVisibilityChange() {
      var _this3 = this;

      window.addEventListener('scroll', function () {
        var screenTopOffset = window.pageYOffset;
        var screenBottomOffset = window.pageYOffset + window.innerHeight;
        for (var i = 0; i < _this3.subNavTags.length; i++) {
          if (_this3.subNavTags[i].offsetTop > screenTopOffset && _this3.subNavTags[i].offsetTop < screenBottomOffset) {
            _this3.activeSubNavTag.classList.remove(_consts.consts.BRAND_SUB_NAV_NAVTAG_ACTIVE);
            _this3.activeSubNavTag = document.querySelector('[href=\'#' + _this3.subNavTagClass + i + '\']');
            _this3.activeSubNavTag.classList.add(_consts.consts.BRAND_SUB_NAV_NAVTAG_ACTIVE);
          }
        }
        var offsetDelta = screenTopOffset - _this3.previousScrollVal;
        if (!_this3.isOpenDropdown() && offsetDelta !== 0) {
          offsetDelta > 0 ? _this3.hideNavBar() : _this3.showNavBar();
        }
        _this3.previousScrollVal = screenTopOffset;
      }, {
        capture: true,
        passive: true
      });
    }
  }, {
    key: 'scrollToElementManual',
    value: function scrollToElementManual(id) {
      var to = document.querySelector(id).offsetTop - window.innerHeight / 2 + 60;
      var element = document.body;
      var isIE = false || !!document.documentMode;
      var duration = 300;
      if (isIE) {
        element = document.documentElement;
      }

      if (duration <= 0) return;
      var from = element.scrollTop;
      var difference = to - from;
      var perTick = difference / duration * 10;

      setTimeout(function () {
        element.scrollTop = to;
      }, duration);
      duration = duration - 10;

      while (duration > 0) {
        setTimeout(function () {
          element.scrollTop += perTick;
        }, duration);
        duration = duration - 10;
      }
    }
  }, {
    key: 'scrollToElement',
    value: function scrollToElement(targetElement) {
      document.querySelector(targetElement).scrollIntoView({
        behavior: 'smooth',
        block: 'center'
      });
    }
  }, {
    key: 'scrollToTop',
    value: function scrollToTop(scrollDuration) {
      var intervalStep = 15;
      var scrollStep = -window.pageYOffset / (scrollDuration / intervalStep);
      var scrollInterval = setInterval(function () {
        window.pageYOffset !== 0 ? window.scrollBy(0, scrollStep) : clearInterval(scrollInterval);
      }, intervalStep);
    }
  }, {
    key: 'hideNavBar',
    value: function hideNavBar() {
      if (this.menuBarSelector.classList.contains(_consts.consts.BRAND_TOPNAV_MENU_BAR_ANIM_UP)) return;
      this.menuBarSelector.classList.add(_consts.consts.BRAND_TOPNAV_MENU_BAR_ANIM_UP);
      this.breadcrumbSelector.classList.add(_consts.consts.BRAND_SUB_NAV_ANIM_UP);
      this.navBarVisibilityBtn.classList.remove(_consts.consts.BRAND_NAVIGATON_TOP_MENU_BAR_VISIBILITY_BTN_VISIBLE);
    }
  }, {
    key: 'showNavBar',
    value: function showNavBar() {
      if (!this.menuBarSelector.classList.contains(_consts.consts.BRAND_TOPNAV_MENU_BAR_ANIM_UP)) return;
      this.menuBarSelector.classList.remove(_consts.consts.BRAND_TOPNAV_MENU_BAR_ANIM_UP);
      this.breadcrumbSelector.classList.remove(_consts.consts.BRAND_SUB_NAV_ANIM_UP);
      this.navBarVisibilityBtn.classList.add(_consts.consts.BRAND_NAVIGATON_TOP_MENU_BAR_VISIBILITY_BTN_VISIBLE);
    }
  }, {
    key: 'isOpenDropdown',
    value: function isOpenDropdown() {
      for (var i = 0; i < this.dropdownSelectors.length; i++) {
        if (this.dropdownSelectors[i].classList.contains('is-visible')) {
          return true;
        }
      }
      return false;
    }
  }]);
  return BrandSubNavigation;
}();

exports.default = BrandSubNavigation;

/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(10);

__webpack_require__(8);

/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _classCallCheck2 = __webpack_require__(2);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(3);

var _createClass3 = _interopRequireDefault(_createClass2);

var _consts = __webpack_require__(24);

var _subNavigation = __webpack_require__(8);

var _subNavigation2 = _interopRequireDefault(_subNavigation);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

__webpack_require__(27);

var BrandTopNavigation = function () {
  function BrandTopNavigation() {
    (0, _classCallCheck3.default)(this, BrandTopNavigation);

    var isSpecMode = document.head.querySelector('meta[name=' + _consts.consts.BRAND_SPEC_RUN_MODE + ']') !== null;
    if (isSpecMode) return;
    var brandHeader = document.querySelector('.' + _consts.consts.BRAND_HEADER);
    var topLinksList = document.querySelectorAll('.' + _consts.consts.BRAND_NAVIGATION_TOP_MENU_LINK_EXPANDABLE);
    var burgerToggle = document.querySelectorAll('.' + _consts.consts.BRAND_NAVIGATION_TOP_MENU_BURGERTOGGLE);
    this.addVisibleToggleEvent(topLinksList);
    this.addVisibleCustomElementToggleEvent(burgerToggle);
    this.closeOnClickOutside(brandHeader);
    this.setGridPositionForDropdownColumns();
    this.brandSubNavigation = new _subNavigation2.default();
  }

  (0, _createClass3.default)(BrandTopNavigation, [{
    key: 'hideAllVisibleLinks',
    value: function hideAllVisibleLinks(node) {
      var visibleLinks = node.querySelectorAll('.' + _consts.consts.BRAND_IS_VISIBLE);
      for (var i = 0; i < visibleLinks.length; i++) {
        visibleLinks[i].classList.remove(_consts.consts.BRAND_IS_VISIBLE);
      }
    }
  }, {
    key: 'closeOnClickOutside',
    value: function closeOnClickOutside(brandHeader) {
      var _this = this;

      if (!brandHeader) return;

      window.addEventListener('click', function (event) {
        if (!brandHeader.contains(event.target)) {
          _this.hideAllVisibleLinks(document.querySelector('.' + _consts.consts.BRAND_NAVIGATION_TOP_MENU));
        }
      });
    }
  }, {
    key: 'disableBodyOverflow',
    value: function disableBodyOverflow() {
      var body = document.querySelector('body');
      body.classList.toggle(_consts.consts.BRAND_NAVIGATION_NO_SCROLL);
    }
  }, {
    key: 'addVisibleCustomElementToggleEvent',
    value: function addVisibleCustomElementToggleEvent(linkList) {
      var _this2 = this;

      for (var i = 0; i < linkList.length; i++) {
        linkList[i].addEventListener('click', function (event) {
          _this2.disableBodyOverflow();
          event.preventDefault();
          event.target.classList.toggle(_consts.consts.BRAND_IS_VISIBLE);
          var customElementTarget = void 0;
          var customElementTargetClass = event.target.getAttribute('data-brand-toggle-target');
          if (customElementTargetClass) {
            customElementTarget = document.querySelectorAll('.' + customElementTargetClass);
          }
          if (customElementTarget) {
            for (var j = 0; j < customElementTarget.length; j++) {
              customElementTarget[j].classList.toggle(_consts.consts.BRAND_IS_VISIBLE);
            }
          }
        });
      }
    }
  }, {
    key: 'addVisibleToggleEvent',
    value: function addVisibleToggleEvent(linkList) {
      var _this3 = this;

      for (var link = 0; link < linkList.length; link++) {
        linkList[link].addEventListener('click', function (event) {
          event.preventDefault();
          var isVisible = event.target.classList.contains(_consts.consts.BRAND_IS_VISIBLE);
          _this3.hideAllVisibleLinks(event.target.parentNode.parentNode);
          if (isVisible) {
            event.target.classList.remove(_consts.consts.BRAND_IS_VISIBLE);
          } else {
            event.target.classList.add(_consts.consts.BRAND_IS_VISIBLE);
          }
        });
      }
    }
  }, {
    key: 'setGridPositionForDropdownColumns',
    value: function setGridPositionForDropdownColumns() {
      var brandNavDropdown = document.querySelectorAll('.' + _consts.consts.BRAND_NAVIGATION_DROPDOWN_GRID);
      for (var i = 0; i < brandNavDropdown.length; i++) {
        var columnCounter = 1;
        var dropdownSectionsAmount = brandNavDropdown[i].children.length;
        for (var j = 0; j < dropdownSectionsAmount; j++) {
          columnCounter = columnCounter > Math.round(dropdownSectionsAmount / 2) ? 1 : columnCounter;
          var row = j < Math.round(dropdownSectionsAmount / 2) ? 1 : 2;
          brandNavDropdown[i].children[j].style.msGridRow = row;
          brandNavDropdown[i].children[j].style.msGridColumn = columnCounter;
          brandNavDropdown[i].children[j].style.gridRow = row;
          brandNavDropdown[i].children[j].style.gridColumn = columnCounter++;
        }
      }
    }
  }]);
  return BrandTopNavigation;
}();

var init = function init() {
  var brandNavigation = new BrandTopNavigation();
  if (!brandNavigation) {
    console.error('Loading navbar failed');
  }
};

if (document.readyState === 'interactive' || document.readyState === 'complete') {
  init();
} else {
  document.addEventListener('DOMContentLoaded', function () {
    init();
  });
}

/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(12), __esModule: true };

/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(13);
var $Object = __webpack_require__(5).Object;
module.exports = function defineProperty(it, key, desc) {
  return $Object.defineProperty(it, key, desc);
};


/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(14);
// 19.1.2.4 / 15.2.3.6 Object.defineProperty(O, P, Attributes)
$export($export.S + $export.F * !__webpack_require__(0), 'Object', { defineProperty: __webpack_require__(6).f });


/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(4);
var core = __webpack_require__(5);
var ctx = __webpack_require__(15);
var hide = __webpack_require__(17);
var has = __webpack_require__(23);
var PROTOTYPE = 'prototype';

var $export = function (type, name, source) {
  var IS_FORCED = type & $export.F;
  var IS_GLOBAL = type & $export.G;
  var IS_STATIC = type & $export.S;
  var IS_PROTO = type & $export.P;
  var IS_BIND = type & $export.B;
  var IS_WRAP = type & $export.W;
  var exports = IS_GLOBAL ? core : core[name] || (core[name] = {});
  var expProto = exports[PROTOTYPE];
  var target = IS_GLOBAL ? global : IS_STATIC ? global[name] : (global[name] || {})[PROTOTYPE];
  var key, own, out;
  if (IS_GLOBAL) source = name;
  for (key in source) {
    // contains in native
    own = !IS_FORCED && target && target[key] !== undefined;
    if (own && has(exports, key)) continue;
    // export native or passed
    out = own ? target[key] : source[key];
    // prevent global pollution for namespaces
    exports[key] = IS_GLOBAL && typeof target[key] != 'function' ? source[key]
    // bind timers to global for call from export context
    : IS_BIND && own ? ctx(out, global)
    // wrap global constructors for prevent change them in library
    : IS_WRAP && target[key] == out ? (function (C) {
      var F = function (a, b, c) {
        if (this instanceof C) {
          switch (arguments.length) {
            case 0: return new C();
            case 1: return new C(a);
            case 2: return new C(a, b);
          } return new C(a, b, c);
        } return C.apply(this, arguments);
      };
      F[PROTOTYPE] = C[PROTOTYPE];
      return F;
    // make static versions for prototype methods
    })(out) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
    // export proto methods to core.%CONSTRUCTOR%.methods.%NAME%
    if (IS_PROTO) {
      (exports.virtual || (exports.virtual = {}))[key] = out;
      // export proto methods to core.%CONSTRUCTOR%.prototype.%NAME%
      if (type & $export.R && expProto && !expProto[key]) hide(expProto, key, out);
    }
  }
};
// type bitmap
$export.F = 1;   // forced
$export.G = 2;   // global
$export.S = 4;   // static
$export.P = 8;   // proto
$export.B = 16;  // bind
$export.W = 32;  // wrap
$export.U = 64;  // safe
$export.R = 128; // real proto method for `library`
module.exports = $export;


/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

// optional / simple context binding
var aFunction = __webpack_require__(16);
module.exports = function (fn, that, length) {
  aFunction(fn);
  if (that === undefined) return fn;
  switch (length) {
    case 1: return function (a) {
      return fn.call(that, a);
    };
    case 2: return function (a, b) {
      return fn.call(that, a, b);
    };
    case 3: return function (a, b, c) {
      return fn.call(that, a, b, c);
    };
  }
  return function (/* ...args */) {
    return fn.apply(that, arguments);
  };
};


/***/ }),
/* 16 */
/***/ (function(module, exports) {

module.exports = function (it) {
  if (typeof it != 'function') throw TypeError(it + ' is not a function!');
  return it;
};


/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(6);
var createDesc = __webpack_require__(22);
module.exports = __webpack_require__(0) ? function (object, key, value) {
  return dP.f(object, key, createDesc(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};


/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(1);
module.exports = function (it) {
  if (!isObject(it)) throw TypeError(it + ' is not an object!');
  return it;
};


/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = !__webpack_require__(0) && !__webpack_require__(7)(function () {
  return Object.defineProperty(__webpack_require__(20)('div'), 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(1);
var document = __webpack_require__(4).document;
// typeof document.createElement is 'object' in old IE
var is = isObject(document) && isObject(document.createElement);
module.exports = function (it) {
  return is ? document.createElement(it) : {};
};


/***/ }),
/* 21 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.1 ToPrimitive(input [, PreferredType])
var isObject = __webpack_require__(1);
// instead of the ES6 spec version, we didn't implement @@toPrimitive case
// and the second argument - flag - preferred type is a string
module.exports = function (it, S) {
  if (!isObject(it)) return it;
  var fn, val;
  if (S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  if (typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it))) return val;
  if (!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  throw TypeError("Can't convert object to primitive value");
};


/***/ }),
/* 22 */
/***/ (function(module, exports) {

module.exports = function (bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};


/***/ }),
/* 23 */
/***/ (function(module, exports) {

var hasOwnProperty = {}.hasOwnProperty;
module.exports = function (it, key) {
  return hasOwnProperty.call(it, key);
};


/***/ }),
/* 24 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var consts = {
  BRAND_HEADER: 'BrandHeader',
  BRAND_NAVIGATION_TOP_MENU: 'BrandNavigationTopMenu',
  BRAND_NAVIGATION_TOP_MENU_BAR: 'BrandNavigationTopMenu-bar',
  BRAND_SUB_NAVIGATION_BREADCRUMB: 'BrandSubNavBreadcrumb',
  BRAND_NAVIGATION_TOP_MENU_VISIBLE: 'BrandNavigationTopMenu--visible',
  BRAND_NAVIGATON_TOP_MENU_BAR_VISIBILITY_BTN: 'BrandNavigationTopMenu-bar-visibilityBtn',
  BRAND_NAVIGATION_TOP_MENU_LINK: 'BrandNavigationTopMenu-link',
  BRAND_NAVIGATION_NO_SCROLL: 'BrandNavigationTopMenu--noScroll',
  BRAND_NAVIGATION_TOP_MENU_LINK_EXPANDABLE: 'BrandNavigationTopMenu-link--expandable',
  BRAND_NAVIGATION_DROPDOWN_LINK_EXPANDABLE: 'BrandNavigationDropDown-link--expandable',
  BRAND_NAVIGATION_TOP_MENU_BURGERTOGGLE: 'BrandNavigationTopMenu-burgerToggle',
  BRAND_NAVIGATION_DROPDOWN_GRID: 'BrandNavigationDropDown-grid',
  BRAND_NAVIGATION_TOP_MENU_LINK_LOGOUT: 'BrandNavigationTopMenu-link-logOut',
  BRAND_SPEC_RUN_MODE: 'BrandNavigationRunMode',
  BRAND_IS_VISIBLE: 'is-visible'
};
exports.consts = consts;

/***/ }),
/* 25 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var brandSubNav = 'BrandSubNavBreadcrumb';

var consts = {
  BRAND_SUB_NAV: brandSubNav,
  BRAND_SUB_NAV_DROPDOWN: brandSubNav + '-dropdown',
  BRAND_SUB_NAV_DROPDOWN_VISIBLE: 'is-visible',
  BRAND_SUB_NAV_DROPDOWN_HIDDEN: 'is-hidden',
  BRAND_SUB_NAV_CONTENT: brandSubNav + '-content',
  BRAND_SUB_NAV_CONTENT_TRIGGER: brandSubNav + '-content-trigger',
  BRAND_SUB_NAV_TAG_CLASS: 'sub-navigation-tag',
  BRAND_SUB_NAV_NAVTAG: brandSubNav + '-dropdown-tag',
  BRAND_SUB_NAV_NAVTAG_ACTIVE: 'is-active',
  BRAND_HEADER: 'BrandHeader',
  BRAND_HEADER_STATUS_CONTAINER: 'BrandHeader-status',
  BRAND_NAVIGATION_TOP_MENU_BAR: 'BrandNavigationTopMenu-bar',
  BRAND_TOPNAV_MENU_BAR_ANIM_UP: 'BrandNavigationTopMenu-bar--anim-up',
  BRAND_SUB_NAVIGATION_BREADCRUMB: '' + brandSubNav,
  BRAND_NAVIGATON_TOP_MENU_BAR_VISIBILITY_BTN: 'BrandNavigationTopMenu-bar-visibilityBtn',
  BRAND_NAVIGATON_TOP_MENU_BAR_VISIBILITY_BTN_VISIBLE: 'is-visible',
  BRAND_NAVIGATION_TOP_MENU_LINK: 'BrandNavigationTopMenu-link',
  BRAND_SUB_NAV_ARROW_LEFT: '>',
  BRAND_SUB_NAV_SPAN: brandSubNav + '-content-span',
  BRAND_SUB_NAV_ANIM_UP: brandSubNav + '--anim-up'
};

exports.consts = consts;

/***/ }),
/* 26 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 27 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ })
/******/ ]);


// WEBPACK FOOTER //
// ../cdn/bundle.js